module.exports = __webpack_public_path__ + "img/SPtraining.40a9a45b.png";